import React, { useState, useEffect } from 'react'
// import DatePicker from "react-datepicker";
import { DatePicker } from "antd";
import apolloclient from "../../../../apollo_client";
import moment from 'moment';
import { Modal } from "antd";
import { useIndexedDB } from 'react-indexed-db';
import { simformQuery, headerMutation, getTrainerSign, stcinerstMutation } from '../SimulatorQuery/SimulatorFormQuery'
import { Formik, Form, ErrorMessage } from 'formik';
import './ConductSimulator.css'
import blankImage from './../../../../assets/images/blankimage.jpg'
import Loading from './../../../../assets/images/loading.gif'
import {
    Calender,
  } from "../../../formitems/Index";
function ConductSimulator({ userDetails, users, locations, simFormMap, trainessMap, setAddNew }) {
    const [loading, setloading] = useState(false)
    const [active, setactive] = useState("header")
    const [trainersignurl, settrainersignurl] = useState("")
    const [openModal, SetOpenModal] = useState(false);
    const [trainersignlist, settrainersignlist] = useState({})
    const { add } = useIndexedDB('sfrid');
    const { add: Addscid } = useIndexedDB('stcid');
    const [header, setheader] = useState({
        clientname: userDetails.client.clientname,
        date: new Date(),
        fleet: userDetails.fleet?.aircraft,
        sid: '',
        simlocation: '',
        simtype: '',
        simreg: '',
        simformname: '',
        simformid: '',
        name: userDetails.name,
        rank: userDetails.rank?.rank,
        licence: userDetails.licence,
        traineename: '',
        traineecrewid: '',
        traineeecode: '',
        traineerank: '',
        traineeranksid: '',
        traineelicense: '',
        traineeemail: ''
    });
    useEffect(() => {
        apolloclient.query({
            query: getTrainerSign,
            variables: {
                id: users.user
            }
        }
        ).then(response => {
            settrainersignlist(response.data.aatmsv4_simulatorinst[0])
            SetOpenModal(true)
        });
    }, [])
    if (loading) {

        return (< img style={{ padding: 100 }} src={loading ? Loading : null}
            height="50%"
            alt=""
            width="50%"
        />)
    }
    return (

        <div>
            <Modal title="Select Trainer Signature" visible={openModal}>
                {
                    trainersignlist && trainersignlist?.examinersign !== "" &&
                    (
                        <div>
                            <label>
                                <h3>Which signature do you want to use ?</h3>
                            </label>
                                <h4>Examiner Signature:</h4>
                            <div className="camera-container pointer">
                                <img src={trainersignlist.examinersign} style={{ height: 100 }} alt="examiner Sign" onClick={() => { SetOpenModal(false); settrainersignurl(trainersignlist.examinersign) }} />
                            </div>
                                <h4>Instructor Signature:</h4>
                            <div className="camera-container pointer">
                                <img src={trainersignlist.instructorsign} alt="instructor Sign" style={{ height: 100 }} onClick={() => { SetOpenModal(false); settrainersignurl(trainersignlist.instructorsign) }} />
                            </div>
                                <h4>I will manually sign this form:</h4>
                            <div className="camera-container pointer">
                                <img src={blankImage} alt="instructor Sign" style={{ height: 100 }} onClick={() => { SetOpenModal(false); settrainersignurl("") }} />
                            </div>
                        </div>
                    )

                }
            </Modal>
            
            <div>
                <Formik
                    initialValues={header}
                    enableReinitialize
                    validate={values => {
                        const errors = {};
                        if (!values.simlocation) {
                            errors.simlocation = "Location is Required"
                        }
                        if (!values.simformid) {
                            errors.simformid = "SimForm Selection is Required"
                        }
                        if (!values.traineename) {
                            errors.traineename = "Trainee is Required"
                        }
                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setloading(true)
                        apolloclient.query(
                            {
                                query: simformQuery,
                                variables: {
                                    id: values.simformid
                                }
                            }
                        ).then(simformdet => {
                            let simformdetdata = simformdet.data.aatmsv4_simforms[0];
                            let emaillist = userDetails.emailofficial + "," + values.traineeemail;
                            emaillist = simformdetdata.manageremail && simformdetdata.manageremail != null ? emaillist + "," + simformdetdata.manageremail : emaillist;
                            apolloclient.mutate({
                                mutation: headerMutation,
                                variables: {
                                    date: moment(values.date).format('yyyy-MM-DD'),
                                    category: simformdetdata.category,
                                    simlocation: values.simlocation,
                                    simreg: values.simreg,
                                    simtype: values.simtype,
                                    sid: values.sid,
                                    traineeid: values.traineecrewid,
                                    traineeecode: values.traineeecode,
                                    traineename: values.traineename,
                                    traineerank: values.traineerank,
                                    traineerankid: values.traineeranksid,
                                    traineelicence: values.traineelicense,
                                    trainerid: users.user,
                                    trainerecode: userDetails.ecode,
                                    trainername: userDetails.name,
                                    trainerlicense: userDetails.licence,
                                    trainerrank: userDetails?.rank.rank,
                                    trainerrankid: userDetails?.rank?.ranksid,
                                    clientid: simformdetdata.clientsid,
                                    clientname: simformdetdata.clientname,
                                    fleetid: userDetails.fleetsid,
                                    simformid: simformdetdata.simformid,
                                    simformname: simformdetdata.simformname,
                                    minutes: simformdetdata.minutes,
                                    subcategory: simformdetdata.subcategory.replace(/['"]+/g, ''),
                                    tc: simformdetdata.tc,
                                    ntc: simformdetdata.ntc,
                                    remarks: simformdetdata.remarks,
                                    result: simformdetdata.result,
                                    reginfo: simformdetdata.reginfo,
                                    validity: simformdetdata.validity,
                                    manageremail: emaillist,
                                    trainersign: trainersignurl,
                                    validtill: moment(new Date(), "yyyy-MM-DD").add(simformdetdata.validity, 'days').format("YYYY-MM-DD"),
                                    timestamp: new Date().toISOString(),
                                    wlm: "3",
                                    com: "3",
                                    tkn: "3",
                                    skil: "",
                                    app: "3",
                                    attitude: "",
                                    cal: 9,
                                    pdm: "3",
                                    fpa: "3",
                                    fpm: "3",
                                    saw: "3",
                                    knowledge: "",
                                    ltw: "3",
                                    remarkstext: "",
                                    resulttext: ""
                                }
                            }).then((response) => {
                                let data = response.data.insert_aatmsv4_simformrecords.returning[0];
                                let i = 1;
                                let index = 0;
                                let length = simformdetdata.stcmaps.length;
                                let stcdataList = [];
                                if (simformdetdata.stcmaps && simformdetdata.stcmaps.length > 0) {
                                    simformdetdata.stcmaps.forEach(async (stcmapdata) => {
                                        index = index + 1;
                                        let stcresponse = await apolloclient.mutate({
                                            mutation: stcinerstMutation,
                                            variables: {
                                                ata: stcmapdata.ata,
                                                clientname: simformdetdata.clientname,
                                                clientsid: simformdetdata.clientsid,
                                                fleetsid: userDetails.fleetsid,
                                                phase: stcmapdata.phase,
                                                sequence: index,
                                                sfrid: data.sfrid,
                                                simformid: simformdetdata.simformid,
                                                stcid: stcmapdata.stcid,
                                                stcname: stcmapdata.stcname,
                                                stcshortname: stcmapdata.stcshortname,
                                                traineeid: values.traineecrewid,
                                                trainerid: users.user,
                                                patch: "",
                                                score: "3",
                                                sits: "1",
                                                date: moment(values.date).format('yyyy-MM-DD'),
                                            }
                                        })
                                        let stcdata = stcresponse.data.insert_aatmsv4_stcrecords.returning[0];
                                        stcdataList.push(stcdata);
                                        console.log("stcdataList", stcdataList)
                                        if (i === length) {
                                            add({
                                                sfrid: data.sfrid,
                                                active: data.active,
                                                app: data.app,
                                                attitude: data.attitude,
                                                cal: data.cal,
                                                category: data.category,
                                                clentsid: data.clentsid,
                                                clientname: data.clientname,
                                                com: data.com,
                                                date: data.date,
                                                fleetsid: data.fleetsid,
                                                fpa: data.fpa,
                                                fpm: data.fpm,
                                                knowledge: data.knowledge,
                                                ltw: data.ltw,
                                                minutes: data.minutes,
                                                ntc: data.ntc,
                                                pdm: data.pdm,
                                                preview: data.preview,
                                                published: data.published,
                                                reginfo: data.reginfo,
                                                remarks: data.remarks,
                                                remarkstext: data.remarkstext,
                                                result: data.result,
                                                resulttext: data.resulttext,
                                                saw: data.saw,
                                                sid: data.sid,
                                                simformid: data.simformid,
                                                simformname: data.simformname,
                                                simlocation: data.simlocation,
                                                simrecord: data.simrecord,
                                                simtype: data.simtype,
                                                simreg: data.simreg,
                                                stage: data.stage,
                                                skil: data.skil,
                                                subcategory: data.subcategory,
                                                tc: data.tc,
                                                tkn: data.tkn,
                                                traineeecode: data.traineeecode,
                                                traineeid: data.traineeid,
                                                traineelicence: data.traineelicence,
                                                traineename: data.traineename,
                                                traineerank: data.traineerank,
                                                traineerankid: data.traineerankid,
                                                traineesign: data.traineesign,
                                                trainerecode: data.trainerecode,
                                                trainerid: data.trainerid,
                                                trainerlicense: data.trainerlicense,
                                                trainername: data.trainername,
                                                trainerrank: data.trainerrank,
                                                trainerrankid: data.trainerrankid,
                                                trainersign: data.trainersign,
                                                validity: data.validity,
                                                validtill: data.validtill,
                                                wlm: data.wlm,
                                                fleet: userDetails.fleet?.aircraft,
                                                name: userDetails.name,
                                                rank: userDetails.rank?.rank,
                                                licence: userDetails.licence,
                                                manageremail: emaillist,
                                                timestamp: data.timestamp,
                                                stcrecords: stcdataList
                                            }).then(
                                                event => {
                                                    setloading(false)
                                                    setAddNew(false);
                                                    alert("Your progress has been saved! To continue filling this form go back to the Simulator Forms menu and click 'Resume'");
                                                },
                                                error => {
                                                    console.log(error);
                                                }
                                            );
                                        }
                                        i++;
                                    })
                                } else {
                                    add({
                                        sfrid: data.sfrid,
                                        active: data.active,
                                        app: data.app,
                                        attitude: data.attitude,
                                        cal: data.cal,
                                        category: data.category,
                                        clentsid: data.clentsid,
                                        clientname: data.clientname,
                                        com: data.com,
                                        date: data.date,
                                        fleetsid: data.fleetsid,
                                        fpa: data.fpa,
                                        fpm: data.fpm,
                                        knowledge: data.knowledge,
                                        ltw: data.ltw,
                                        minutes: data.minutes,
                                        ntc: data.ntc,
                                        pdm: data.pdm,
                                        preview: data.preview,
                                        published: data.published,
                                        reginfo: data.reginfo,
                                        remarks: data.remarks,
                                        remarkstext: data.remarkstext,
                                        result: data.result,
                                        resulttext: data.resulttext,
                                        saw: data.saw,
                                        sid: data.sid,
                                        simformid: data.simformid,
                                        simformname: data.simformname,
                                        simlocation: data.simlocation,
                                        simrecord: data.simrecord,
                                        simtype: data.simtype,
                                        simreg: data.simreg,
                                        stage: data.stage,
                                        skil: data.skil,
                                        subcategory: data.subcategory,
                                        tc: data.tc,
                                        tkn: data.tkn,
                                        traineeecode: data.traineeecode,
                                        traineeid: data.traineeid,
                                        traineelicence: data.traineelicence,
                                        traineename: data.traineename,
                                        traineerank: data.traineerank,
                                        traineerankid: data.traineerankid,
                                        traineesign: data.traineesign,
                                        trainerecode: data.trainerecode,
                                        trainerid: data.trainerid,
                                        trainerlicense: data.trainerlicense,
                                        trainername: data.trainername,
                                        trainerrank: data.trainerrank,
                                        trainerrankid: data.trainerrankid,
                                        trainersign: data.trainersign,
                                        validity: data.validity,
                                        validtill: data.validtill,
                                        wlm: data.wlm,
                                        fleet: userDetails.fleet?.aircraft,
                                        name: userDetails.name,
                                        rank: userDetails.rank?.rank,
                                        licence: userDetails.licence,
                                        manageremail: emaillist,
                                        timestamp: data.timestamp,
                                        stcrecords: data.stcrecords
                                    }).then(
                                        event => {
                                            setloading(false)
                                            setAddNew(false);
                                            alert("Your progress has been saved! To continue filling this form go back to the Simulator Forms menu and click 'Resume'");
                                        },
                                        error => {
                                            console.log(error);
                                        }
                                    );
                                }

                            })
                        })
                        setSubmitting(false)
                    }}
                >
                    {({ values, setFieldValue, handleChange, handleSubmit }) => {
                        return (

                            <Form>
                                <div>
                                    <div className="table-body-container">
                                        <div className="table-body-header">All Simulators</div>                                       
                                            <div className="header-form1-container">
                                                <div className="header-form1-box header-form1-box--1">
                                                    <div className="">
                                                        <span>Airline: (not modifiable)</span>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        disabled
                                                        name="clientname"
                                                        value={values.clientname}
                                                        onChange={handleChange}
                                                        className="header-form1-input"
                                                    />
                                                </div>
                                                <div className="header-form1-box header-form1-box--2">
                                                    <div className="">
                                                        <span>Select Training Date</span>
                                                    </div>
                                                    <DatePicker
                                                        title="Date"
                                                        name="date"
                                                        className="header-form1-input1 date-picker"
                                                        selected={values.date}
                                                        disabledDate={d => d.isAfter(new Date().setDate(new Date().getDate())) }
                                                        dateFormat="dd/MM/yyyy"
                                                        onChange={(e) => {
                                                            setFieldValue('date', e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="header-form1-box header-form1-box--3">
                                                    <div className="">
                                                        <span>Your Fleet (Not modifiable)</span>
                                                    </div>
                                                    <input
                                                        name="fleet"
                                                        value={values.fleet}
                                                        onChange={handleChange}
                                                        disabled
                                                        className="header-form1-input"
                                                        type="text"
                                                    />
                                                </div>
                                          
                                    
                                                <div className="header-form1-box header-form1-box--4" >
                                                    <div className="">
                                                            <span>Sim Location</span>
                                                        </div>
                                                        <select
                                                    name="simlocation"
                                                    value={values.simlocation}
                                                    onChange={e => {
                                                        locations.map(data => {
                                                            if (data.simlocation === e.target.value) {
                                                                setFieldValue('simtype', data.simtype)
                                                                setFieldValue('simreg', data.simreg)
                                                                setFieldValue('simlocation', data.simlocation)
                                                                setFieldValue('sid', data.sid)
                                                            }
                                                        });
                                                    }}
                                                    className="header-form1-input1 my-select form-control">
                                                    <option disabled value="">Select Sim_Location</option>
                                                    {locations && locations.length > 0 && locations.map((el, i) => (
                                                        <option style={{color:"#262626 !important"}} key={i} value={el.simlocation} >{el.simlocation}</option>
                                                    ))}
                                                    </select>
                                                </div>

                                                <div className="header-form1-box header-form1-box--5">
                                                    <div className="">
                                                        <span>Sim Type</span>
                                                    </div>
                                                    <input
                                                        name="simtype"
                                                        value={values.simtype}
                                                        onChange={handleChange}
                                                        disabled
                                                        className="header-form1-input"
                                                        type="text"
                                                    />
                                                </div>
                                                <div className="header-form1-box header-form1-box--6">
                                                    <div className="">
                                                        <span>Sim Registration</span>
                                                    </div>
                                                    <input
                                                        name="simreg"
                                                        value={values.simreg}
                                                        onChange={handleChange}
                                                        disabled
                                                        className="header-form1-input"
                                                        type="text"
                                                    />
                                                </div>
                                        
                                                <ErrorMessage className="error" name="simlocation" component="div" />

                                       
                                                <div className="header-form1-box header-form1-box--7">
                                                        <div className="">
                                                            <span>Nature of simulator training:</span>
                                                        </div>
                                                        <select
                                                            name="simformid"
                                                            value={values.simformid}
                                                            onChange={e => {
                                                                simFormMap.map(data => {
                                                                    if (data.simformid === e.target.value) {
                                                                        setFieldValue('simformname', data.simformname)
                                                                        setFieldValue('simformid', data.simformid)
                                                                    }
                                                                });


                                                            }}
                                                            className="header-form1-input1 my-select form-control">
                                                            <option disabled value="" >Select your Simulator Form</option>
                                                            {
                                                                simFormMap && simFormMap.length > 0 && simFormMap.map((el, i) => (
                                                                    <option style={{color:"#262626 !important"}} key={i} value={el.simformid}>{el.simformname}</option>
                                                                ))
                                                            }
                                                        </select>
                                                </div>                              
                                                    <ErrorMessage className="error" name="simformid" component="div" />
                                                
                                                <div className="header-form-box header-form-box--8">
                                                        <div className="">
                                                            <span>Trainer Name (Not modifiable)</span>
                                                        </div>
                                                        <input
                                                            name="name"
                                                            value={values.name}
                                                            onChange={handleChange}
                                                            disabled
                                                            className="header-form-input"
                                                            type="text"
                                                        />
                                                </div>
                                                <div className="header-form1-box header-form1-box--9">
                                                        <div className="">
                                                            <span>Rank</span>
                                                        </div>
                                                        <input
                                                            name="rank"
                                                            value={values.rank}
                                                            onChange={handleChange}
                                                            disabled
                                                            className="header-form1-input"
                                                            type="text"
                                                        />
                                                </div>
                                                <div className="header-form1-box header-form1-box--10">
                                                        <div className="">
                                                            <span>Licence</span>
                                                        </div>
                                                        <input
                                                            name="licence"
                                                            value={values.licence}
                                                            onChange={handleChange}
                                                            disabled
                                                            className="header-form1-input"
                                                            type="text"
                                                        />
                                                </div>
                                            
                                                <div className="header-form1-box header-form1-box--11">
                                                        <div className="">
                                                            <span>Select Trainee Name</span>
                                                        </div>
                                                
                                                        <select
                                                            name="traineename"
                                                            value={values.traineename}
                                                            onChange={e => {
                                                                trainessMap.map(data => {
                                                                    if (data.name === e.target.value) {
                                                                        setFieldValue('traineename', data.name);
                                                                        setFieldValue('traineecrewid', data.crewid);
                                                                        setFieldValue('traineerank', data.rank?.rank);
                                                                        setFieldValue('traineeranksid', data.rank?.ranksid);
                                                                        setFieldValue('traineelicense', data.license);
                                                                        setFieldValue('traineeecode', data.ecode);
                                                                        setFieldValue('traineeemail', data.email)
                                                                    }
                                                                });

                                                            }}
                                                            className="header-form1-input1 my-select form-control">
                                                            <option disabled value="">Select Trainee</option>
                                                            {trainessMap && trainessMap.length > 0 && trainessMap.map((el, i) => (
                                                                <option style={{color:"#262626 !important"}} key={i} value={el.name} >{el.name}</option>
                                                            ))}
                                                        </select>
                                                </div>                    

                                                <div className="header-form1-box header-form1-box--12">
                                                            <div className="">
                                                                <span>Rank</span>
                                                            </div>
                                                            <input
                                                                name="traineerank"
                                                                value={values.traineerank}
                                                                onChange={handleChange}
                                                                disabled
                                                                className="header-form1-input"
                                                                type="text"
                                                            />
                                                </div>
                                                <div className="header-form1-box header-form1-box--13">
                                                            <div className="">
                                                                <span>Licence</span>
                                                            </div>
                                                            <input
                                                                name="traineelicense"
                                                                value={values.traineelicense}
                                                                onChange={handleChange}
                                                                disabled
                                                                className="header-form1-input"
                                                                type="text"
                                                            />
                                                </div>
                                       
                                       
                                            <ErrorMessage className="error" name="traineename" component="div" />
                                         
                                                <div className="header-form1-box header-form1-box--14 simulator-buttons ">
                                                    <div className="simulator-submit-btn">
                                                       
                                                        <div className="add-btn ">
                                                            <button type="submit" onClick={handleSubmit}
                                                                className="add-button"> 
                                                                 Save And Continue
                                                                <i style={{marginLeft:"5px"}} className="fa fa-save" />
                                                               
                                                                </button>
                                                        </div>

                                                        <div  style={{marginLeft:"10px"}} className="discard-btn">
                                                            <button
                                                                className="discard-button"
                                                                onClick={() => {
                                                                    setAddNew(false);
                                                                }} >     Discard
                                                                <i style={{marginLeft:"5px"}} className="fa fa-trash" />
                                                            
                                                                </button>
                                                        </div>

                                                    </div>

                                                </div>
                                           
                                        </div>
                                    </div>
                                </div>

                            </Form>
                        )
                    }}

                </Formik>
            </div >
        </div >
    )
}

export default ConductSimulator
